/*eslint-disable*/
import { useState } from "react";
import React from "react";
import { NavLink as NavLinkRRD, Link, useLocation } from "react-router-dom";
import { PropTypes } from "prop-types";
import play from "../../assets/img/play.svg";
import Preview from "assets/img/DashboardIcons/preview.svg";


import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { logout } from "store/actions/authActions";
import NextLogo from "../../assets/img/Mpink.png";
import { useEffect } from "react";
import { getDriverApp } from "store/actions/driverAction";
import { getFilteredRoutes } from "utils/getFilteredRoutes";

const Sidebar = (props = { routes: [{}] }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { hide } = props;
  const { user, userPermissions } = useSelector((state) => state.auth);
  const { restaurantsDetail } = useSelector((state) => state.restaurant);
  const { driverAppLink } = useSelector((state) => state.driver);

  const [collapseOpen, setCollapseOpen] = useState();
  const toggleCollapse = () => setCollapseOpen(!collapseOpen);
  const closeCollapse = () => setCollapseOpen(false);
  const adminColor= user?.adminColor || restaurantsDetail?.adminColor || "#d70365";

  useEffect(() => {
    dispatch(getDriverApp());
  }, []);

  const createLinks = (routes) => {
    if (!user) return;
    const filteredRoutes = getFilteredRoutes({
      routes,
      user,
      sidebar: true,
      permissions: userPermissions,
    });

    return filteredRoutes.map((route, index) => {
      const isActive =
        location.pathname === route.path ||
        location.pathname.startsWith(route.path);
      return (
        <NavItem key={index}>
          <NavLink
            to={route.path}
            tag={NavLinkRRD}
            onClick={() => closeCollapse()}
            style={{
              backgroundColor: isActive
                ? adminColor
                : "",
            }}
            className={isActive && "nav-link__active"}
          >
            <img
              src={isActive ? route.activeIcon : route.icon}
              className="mx-2"
            />

            {!hide && (
              <p className="mb-0" style={{ fontSize: "0.9rem" }}>
                {route.name}
              </p>
            )}
          </NavLink>
        </NavItem>
      );
    });
  };

  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  return (
    <Navbar
      id="sidenav-main"
      expand="md"
      className={`navbar-vertical fixed-left navbar-light bg-white ${
        hide && "hidden"
      }`}
    >
      <Container fluid>
        <button
          type="button"
          className="navbar-toggler"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="brand">
          {logo ? (
            <NavbarBrand className="pt-2 pb-0 " {...navbarBrandProps}>
              <img
                alt={logo.imgAlt}
                className="navbar-brand-img"
                src={logo.imgSrc}
              />
            </NavbarBrand>
          ) : null}
        </div>
        <Nav className="align-items-center d-md-none">
          <UncontrolledDropdown nav>
            <DropdownToggle nav>
              <Media className="align-items-center">
                <span className="avatar avatar-sm rounded-circle">
                  <img
                    className="img-fluid"
                    alt="logo"
                    src={user?.restaurantLogo || NextLogo}
                  />
                </span>
              </Media>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow " right>
              <DropdownItem onClick={() => dispatch(logout())}>
                <i className="ni ni-user-run" />
                <span>Logout</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
        <Collapse navbar isOpen={collapseOpen}>
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo?.innerLink ? (
                    <Link to={logo?.innerLink}>
                      <img alt={logo?.imgAlt} src={logo?.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo?.outterLink}>
                      <img alt={logo?.imgAlt} src={logo?.imgSrc} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close align-self-center" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          <Nav navbar>{createLinks(routes)}</Nav>
          <Nav navbar className="mt-auto">
            {user?.type != "admin" && (
              <>
                <NavItem className="my-2">
                  <NavLink
                    className="d-flex justify-content-center align-items-center"
                    href={driverAppLink || ""}
                    style={{
                      border: `2px solid ${
                        adminColor
                      }`,
                      borderRadius: "8px",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src={play}
                      height={40}
                      width={40}
                      onClick={() => setEditingIndex(index)}
                      style={{
                        marginLeft: "-10px",
                      }}
                    />

                    {!hide && (
                      <p
                        className="mb-0 text-uppercase"
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Driver APP
                      </p>
                    )}
                  </NavLink>
                </NavItem>

                <NavItem className="my-2">
                  <NavLink
                    className="d-flex justify-content-center align-items-center"
                    onClick={() => {
                      window.open(
                        `https://nexteats-admin.web.app/restaurant/${user?.restaurantID}`,
                        "_blank"
                      );
                    }}
                    style={{
                      border: `2px solid ${
                        adminColor
                      }`,
                      borderRadius: "8px",
                      cursor: "pointer",
                    }}
                  >
                    <img src={Preview} width={25} className="mr-2" />

                    {!hide && (
                      <p
                        className="mb-0 mt-1 text-uppercase"
                        style={{ fontSize: "13px", fontWeight: "600" }}
                      >
                        Preview Restaurant
                      </p>
                    )}
                  </NavLink>
                </NavItem>
              </>
            )}
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
